import * as React from "react";

import style from "./FileDownloader.module.scss";

export interface FileDownloaderStateProps {
  content: React.ReactElement;
  url: string;
}

export interface FileDownloaderDispatchProps {
  closeModal: () => void;
}

export interface FileDownloaderProps
  extends FileDownloaderDispatchProps,
    FileDownloaderStateProps {}

export const FileDownloader = (props: FileDownloaderProps) => {
  return (
    <main className={style.main}>
      <div className={style.header}>
        <div>{props.content}</div>
      </div>
      <div className={style.body}>
        <div className={style.btnArea}>
          <a
            href={props.url}
            className="btn btn-primary"
            onClick={() => props.closeModal()}
            rel="noopener noreferrer"
            target="_blank"
          >
            {"OK"}
          </a>
          <button
            className="btn btn-secondary"
            onClick={() => props.closeModal()}
          >
            {"キャンセル"}
          </button>
        </div>
      </div>
    </main>
  );
};
